import { render, staticRenderFns } from "./RestaurantGroupMapView.vue?vue&type=template&id=71fe69d4&scoped=true&"
import script from "./RestaurantGroupMapView.vue?vue&type=script&lang=js&"
export * from "./RestaurantGroupMapView.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantGroupMapView.vue?vue&type=style&index=0&id=71fe69d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe69d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
